import { Injectable } from '@angular/core'
import { Headers, Http, Response } from '@angular/http'
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/operator/toPromise'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/catch'
import 'rxjs/add/observable/throw'

import { TransformacionService } from './transformacion.service'
import { PreguntaPrimerNivel } from '../dominio/pregunta-primer-nivel'
import { RespuestaPrimerNivel } from '../dominio/respuesta-primer-nivel'
import { environment } from 'environments/environment'

@Injectable()
export class RespuestaService {

  private urlBase: string = environment.host
  private urlRespuestaPrimerNivel: String = `${this.urlBase}/respuestas/primer-nivel`
  private urlPreguntasPrimerNivel: String = `${this.urlBase}/preguntas/primer-nivel`
  private headers = new Headers({'Content-Type': 'application/json'})

  constructor (private http: Http, private tr: TransformacionService) {}

  obtenerRespuestasTextoAbierto(id): Observable<PreguntaPrimerNivel[]> {
    return this.http
      .get(`${this.urlPreguntasPrimerNivel}/${id}`, { withCredentials: true })
      .map(res => this.transformarRespuesta(res))
      .catch(this.manejarError)
  }

  private manejarError (error: Response | any) {
    let errMsg: string
    if (error instanceof Response) {
      const body = error.json() || ''
      const err = body.error || JSON.stringify(body)
      window['s'] = error
      errMsg = body[0].mensaje
    } else {
      window['s'] = error
      errMsg = error.message ? error.message : error.toString()
    }
    return Observable.throw(errMsg)
  }

  private transformarRespuesta(res: any): RespuestaPrimerNivel[] {
    return res.json().data.relationships.respuestas.data.map( r => {
      return new RespuestaPrimerNivel(
        r.id,
        r.attributes.texto,
        r.attributes.textoAbierto,
        r.attributes.indice,
        r.attributes.noAsegurable,
        []
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/servicios/respuesta.service.ts